import { HtmlContentInfoEvidence } from './htmlContentInfoEvidence';

export class HtmlContentInfo {  
    info: HtmlContentInfoEvidence;
}